import React, { memo } from 'react';
import { graphql, useFragment } from 'react-relay';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import { SkeletonNavMenuItems } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/skeleton-nav-menu-items/main.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { AsyncJcsProjectMenuContent_jiraProject$key } from './__generated__/AsyncJcsProjectMenuContent_jiraProject.graphql';

type JcsProjectMenuContentProps = {
	projectFragment: AsyncJcsProjectMenuContent_jiraProject$key;
};

const Skeleton = () => <SkeletonNavMenuItems />;

const LazyJcsProjectMenuContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-jcs-project-menu-content" */ './JcsProjectMenuContent.tsx'
		).then(({ JcsProjectMenuContent }) => JcsProjectMenuContent),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncJcsProjectMenuContent: React.MemoExoticComponent<
	(props: JcsProjectMenuContentProps) => React.JSX.Element
> = memo(({ projectFragment }: JcsProjectMenuContentProps): React.JSX.Element => {
	const asyncJcsProjectMenuContent = useFragment(
		graphql`
			fragment AsyncJcsProjectMenuContent_jiraProject on JiraProject {
				...JcsProjectMenuContent
			}
		`,
		projectFragment,
	);

	return (
		<SidebarBoundary
			id="nav4.sidebar.jcs-project-menu-content"
			packageName="jiraNavigationAppsSidebarNav4JcsProjectMenu"
			teamName="Boysenberry"
			ufoName="nav4.sidebar.jcs-project-menu-content"
		>
			<Placeholder name="nav4.sidebar.jcs-project-menu-content" fallback={<Skeleton />}>
				<LazyJcsProjectMenuContent projectData={asyncJcsProjectMenuContent} />
			</Placeholder>
		</SidebarBoundary>
	);
});
